import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(private httpClientService:HttpClientService) { }

  async getAllCountries(){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Country
    });
    return await firstValueFrom(observable);
  }
}
